
  import Vue from 'vue'
  import DeviceTypeService from '@/services/DeviceTypeService';
import { extractErrorMessage } from '@/utils/Util';

  export default Vue.extend({
    name: 'DeviceTypeDeleteDialog',
    props: ['devicetype'],
    data: () => ({
        localDialog: false,
        alertText: "",
        alertVisible: false,
        alertType: "error",
        loading: false,
    }),
    methods: {
      close() {
        this.localDialog = false;
      },
      clear() {
        this.alertVisible = false;
        this.loading = false;
      },
      dismiss() {
        this.clear();
        this.close();
      },
      confirmDelete() {
        this.loading = true;
      
        DeviceTypeService.deleteDeviceType(this.devicetype.uuid).then(() => {
            this.alertType = "success";
            this.alertText = this.$t('deviceType.successDelete') as string;
            this.alertVisible = true;
            this.loading = false;

            setTimeout(() => { 
                this.$emit("delete", this.devicetype);
                this.dismiss(); 
            }, 2000);
        }).catch((err) => {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('deviceType.errorDelete') + ' ' + extractErrorMessage(err);
            this.alertVisible = true; 
            this.loading = false;
        });
      }
    }
  })
